export const STATE_NAME = 'universities';
